import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoCloseOutline } from "react-icons/io5";
// import IveyLogo from "/iveysvg.svg";
import "./header.css";
import "./Navbar.css";
import menuIcon from "../../assets/images/menu-icon.svg";
import closeIcon from "../../assets/images/close-icon.png";
import logourl from '../../assets/images/logo.png';
import IveyLogo from '../../assets/images/iveysvg.svg';
import featuredimage1 from '../../assets/images/feautred-image1.jpg';
import featuredimage2 from '../../assets/images/featuredimage2.jpg';
import featuredimage3 from '../../assets/images/featured-image3.jpg';
import blacklogo from '../../assets/images/site-logo-dark.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import config from '../../config';
import axios from 'axios';

import ContactPopup from '../ContactPopup';
import { Link } from "react-router-dom";
const Navbar = ({ onOpenForm ,page }) => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopup, setPopup] = useState(false)
  const [selectedTabIndex, setSelectedTabIndex] = useState(null); // Track selected tab
  const [menuItems, setMenuItems] = useState([
    { name: '', subMenus: [{ name: '', link: '' }] } // Initialize with link key
  ]);

  const [projects, setProjects] = useState([]);


  const location = useLocation();

  const toggleMenu = (event) => {
    event.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.documentElement.classList.add('menu-open');
    } else {
      document.documentElement.classList.remove('menu-open');
    }
  }, [isMenuOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
        document.documentElement.classList.add('header-scrolled');
      } else {
        setIsScrolled(false);
        document.documentElement.classList.remove('header-scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);

    if (menuItems.length > 1) {
      const pathname = location.pathname + location.hash;
      const currentIndex = menuItems.findIndex(item => item.mainLink === pathname);

      if (currentIndex === -1) {
        setSelectedTabIndex(null);
      } else {
        setSelectedTabIndex(currentIndex);
      }
    }
  }, [navigate, menuItems, location]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/admin/get-projects`, {
          withCredentials: true
        });
        setProjects(response?.data?.slice(0, 5));
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    fetchProjects();
  }, []);


  const fetchMenuDetails = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/admin/get-menu-items/`, { withCredentials: true });

      if (response?.data.length > 0) {
        setMenuItems(response?.data[0]?.menuData);
        // setMenuId(response.data[0]._id);
        // setAddNew(false);
      } else {
        // setAddNew(true);
      }
    } catch (err) {
      // setError('Failed to fetch location details');
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenuDetails();
  }, []);

  const toggleMenuTab = (index) => {
    setSelectedTabIndex(index);
  }

  const megamenusliderSettings = {
    dots: false,
    infinite: true,
    speed: 700,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ]
  };
  return (
    <div>
      <div className="navbar-wrapper" style={{ backgroundColor: page === "blog" ? "#353434" : "" }}>
        <div className="nav-logo-left">
          <Link to="/">
            <div className="nav-log-wapper nav-home-btn ">
              <svg
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.3013 3.0263L2.5 6.98073V11.2487C2.5 11.3592 2.5439 11.4652 2.62204 11.5433C2.70018 11.6215 2.80616 11.6654 2.91667 11.6654L5.8349 11.6578C5.94504 11.6573 6.05049 11.6131 6.12818 11.535C6.20587 11.457 6.24948 11.3513 6.24948 11.2411V8.7487C6.24948 8.63819 6.29338 8.53221 6.37152 8.45407C6.44966 8.37593 6.55564 8.33203 6.66615 8.33203H8.33281C8.44332 8.33203 8.5493 8.37593 8.62744 8.45407C8.70558 8.53221 8.74948 8.63819 8.74948 8.7487V11.2393C8.74931 11.2942 8.75996 11.3485 8.78082 11.3992C8.80168 11.4499 8.83235 11.496 8.87106 11.5348C8.90977 11.5736 8.95576 11.6044 9.00639 11.6255C9.05703 11.6465 9.11132 11.6573 9.16615 11.6573L12.0833 11.6654C12.1938 11.6654 12.2998 11.6215 12.378 11.5433C12.4561 11.4652 12.5 11.3592 12.5 11.2487V6.97787L7.69974 3.0263C7.64331 2.98081 7.573 2.95601 7.50052 2.95601C7.42804 2.95601 7.35774 2.98081 7.3013 3.0263ZM14.8854 5.71406L12.7083 3.91953V0.3125C12.7083 0.22962 12.6754 0.150134 12.6168 0.0915292C12.5582 0.0329241 12.4787 0 12.3958 0H10.9375C10.8546 0 10.7751 0.0329241 10.7165 0.0915292C10.6579 0.150134 10.625 0.22962 10.625 0.3125V2.20339L8.29349 0.285156C8.06974 0.101036 7.78898 0.000368059 7.49922 0.000368059C7.20946 0.000368059 6.92869 0.101036 6.70495 0.285156L0.113022 5.71406C0.0813781 5.74022 0.0551978 5.77235 0.035977 5.80863C0.0167562 5.8449 0.00487152 5.88461 0.00100209 5.92548C-0.00286734 5.96635 0.0013543 6.00759 0.0134258 6.04682C0.0254973 6.08606 0.0451821 6.12254 0.0713554 6.15417L0.735418 6.96146C0.76152 6.9932 0.793625 7.01948 0.829896 7.03879C0.866168 7.05811 0.905892 7.07008 0.946796 7.07402C0.9877 7.07796 1.02898 7.0738 1.06827 7.06177C1.10756 7.04974 1.1441 7.03008 1.17578 7.00391L7.3013 1.95859C7.35774 1.91311 7.42804 1.8883 7.50052 1.8883C7.573 1.8883 7.64331 1.91311 7.69974 1.95859L13.8255 7.00391C13.8572 7.03008 13.8936 7.04976 13.9329 7.06184C13.9721 7.07391 14.0133 7.07813 14.0542 7.07426C14.0951 7.07039 14.1348 7.05851 14.1711 7.03929C14.2073 7.02006 14.2395 6.99388 14.2656 6.96224L14.9297 6.15495C14.9558 6.12314 14.9754 6.08647 14.9874 6.04706C14.9993 6.00765 15.0033 5.96627 14.9992 5.9253C14.9951 5.88433 14.9829 5.84458 14.9634 5.80833C14.9439 5.77208 14.9174 5.74004 14.8854 5.71406Z"
                  fill="white"
                />
              </svg>
            </div>
          </Link>
        </div>
        <div className="nav-left">
          <button
            className="nav-connact-btn"
            onClick={() => setPopup(true)}
          // onClick={() => onOpenForm && onOpenForm()}
          >
            connect
          </button>
        </div>
        <div className="nav-right">
          <div
            className="nav-svg-wrapper"
            onClick={toggleMenu}
          // onClick={() => setMobileMenu(!mobileMenu)}
          >
            <svg
              width="25"
              height="9"
              viewBox="0 0 25 9"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="25" height="2.25" rx="1.125" fill="currentColor" />
              <rect
                y="6.75"
                width="15"
                height="2.25"
                rx="1.125"
                fill="currentColor"
              />
            </svg>
            {/* {isMenuOpen ? <img src={closeIcon} alt="close-icon" style={{color:'black'}}/> : <img src={menuIcon} alt="menu-icon" />} */}

          </div>

        </div>
        <div
          className={`nav-tab-container ${mobileMenu ? "mobilemenu-open" : ""}`}
        >
          <button
            className="nav-close-btn iveyP-black "
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            <IoCloseOutline size={30} />
          </button>
          <ul>
            <li className="iveyP-black navbar-link-btn" onClick={()=>navigate('https://iveydb.com/')}>
              <Link to="#" className="navbar-link-color-btn">
                IVEY design build
              </Link>
            </li>
            <li lassName="navbar-link-btn" onClick={() => window.open('https://iveypunch.com/', '_blank')}>
              <Link to="#"  className="navbar-link-color-btn">
                IVEY PuNCH
              </Link>
            </li>
            <li lassName="navbar-link-btn"  onClick={() => window.open('https://iveyfd.org/', '_blank')}>
              <Link to="#"  className="navbar-link-color-btn">
                IVEY FOUNDATIOn
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="navbar-mobileview">
        <div className="nav-mv-upper">
          <div className="navbar-mobile-left">
            <Link to="/"> <img src={IveyLogo} alt="" /></Link>
          </div>
          <div className="navbar-mobile-right">
            <Link to="/">
              <div className="nav-log-wapper nav-home-btn ">
                <svg
                  width="15"
                  height="12"
                  viewBox="0 0 15 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.3013 3.0263L2.5 6.98073V11.2487C2.5 11.3592 2.5439 11.4652 2.62204 11.5433C2.70018 11.6215 2.80616 11.6654 2.91667 11.6654L5.8349 11.6578C5.94504 11.6573 6.05049 11.6131 6.12818 11.535C6.20587 11.457 6.24948 11.3513 6.24948 11.2411V8.7487C6.24948 8.63819 6.29338 8.53221 6.37152 8.45407C6.44966 8.37593 6.55564 8.33203 6.66615 8.33203H8.33281C8.44332 8.33203 8.5493 8.37593 8.62744 8.45407C8.70558 8.53221 8.74948 8.63819 8.74948 8.7487V11.2393C8.74931 11.2942 8.75996 11.3485 8.78082 11.3992C8.80168 11.4499 8.83235 11.496 8.87106 11.5348C8.90977 11.5736 8.95576 11.6044 9.00639 11.6255C9.05703 11.6465 9.11132 11.6573 9.16615 11.6573L12.0833 11.6654C12.1938 11.6654 12.2998 11.6215 12.378 11.5433C12.4561 11.4652 12.5 11.3592 12.5 11.2487V6.97787L7.69974 3.0263C7.64331 2.98081 7.573 2.95601 7.50052 2.95601C7.42804 2.95601 7.35774 2.98081 7.3013 3.0263ZM14.8854 5.71406L12.7083 3.91953V0.3125C12.7083 0.22962 12.6754 0.150134 12.6168 0.0915292C12.5582 0.0329241 12.4787 0 12.3958 0H10.9375C10.8546 0 10.7751 0.0329241 10.7165 0.0915292C10.6579 0.150134 10.625 0.22962 10.625 0.3125V2.20339L8.29349 0.285156C8.06974 0.101036 7.78898 0.000368059 7.49922 0.000368059C7.20946 0.000368059 6.92869 0.101036 6.70495 0.285156L0.113022 5.71406C0.0813781 5.74022 0.0551978 5.77235 0.035977 5.80863C0.0167562 5.8449 0.00487152 5.88461 0.00100209 5.92548C-0.00286734 5.96635 0.0013543 6.00759 0.0134258 6.04682C0.0254973 6.08606 0.0451821 6.12254 0.0713554 6.15417L0.735418 6.96146C0.76152 6.9932 0.793625 7.01948 0.829896 7.03879C0.866168 7.05811 0.905892 7.07008 0.946796 7.07402C0.9877 7.07796 1.02898 7.0738 1.06827 7.06177C1.10756 7.04974 1.1441 7.03008 1.17578 7.00391L7.3013 1.95859C7.35774 1.91311 7.42804 1.8883 7.50052 1.8883C7.573 1.8883 7.64331 1.91311 7.69974 1.95859L13.8255 7.00391C13.8572 7.03008 13.8936 7.04976 13.9329 7.06184C13.9721 7.07391 14.0133 7.07813 14.0542 7.07426C14.0951 7.07039 14.1348 7.05851 14.1711 7.03929C14.2073 7.02006 14.2395 6.99388 14.2656 6.96224L14.9297 6.15495C14.9558 6.12314 14.9754 6.08647 14.9874 6.04706C14.9993 6.00765 15.0033 5.96627 14.9992 5.9253C14.9951 5.88433 14.9829 5.84458 14.9634 5.80833C14.9439 5.77208 14.9174 5.74004 14.8854 5.71406Z"
                    fill="white"
                  />
                </svg>
              </div>
            </Link>
            <div className="nav-massage-btn nav-home-btn" onClick={() => setPopup(true)}>
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.7727 2.97188C11.8641 2.89922 12 2.96719 12 3.08203V7.875C12 8.49609 11.4961 9 10.875 9H1.125C0.503906 9 0 8.49609 0 7.875V3.08438C0 2.96719 0.133594 2.90156 0.227344 2.97422C0.752344 3.38203 1.44844 3.9 3.83906 5.63672C4.33359 5.99766 5.16797 6.75703 6 6.75234C6.83672 6.75938 7.6875 5.98359 8.16328 5.63672C10.5539 3.9 11.2477 3.37969 11.7727 2.97188ZM6 6C6.54375 6.00938 7.32656 5.31563 7.72031 5.02969C10.8305 2.77266 11.0672 2.57578 11.7844 2.01328C11.9203 1.90781 12 1.74375 12 1.57031V1.125C12 0.503906 11.4961 0 10.875 0H1.125C0.503906 0 0 0.503906 0 1.125V1.57031C0 1.74375 0.0796875 1.90547 0.215625 2.01328C0.932813 2.57344 1.16953 2.77266 4.27969 5.02969C4.67344 5.31563 5.45625 6.00938 6 6Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="nav-right">
              <div
                className="nav-svg-wrapper"
                onClick={toggleMenu}
              >
                <svg
                  width="25"
                  height="9"
                  viewBox="0 0 25 9"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="25"
                    height="2.25"
                    rx="1.125"
                    fill="currentColor"
                  />
                  <rect
                    y="6.75"
                    width="15"
                    height="2.25"
                    rx="1.125"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <hr className="he-nav" />
        <div className="nav-mv-lower">
          <div className="nav-mv-tabs-wrapper">
            <div className="nav-top-tab nav-active-tab " onClick={()=>navigate('https://iveydb.com/')}>
              <Link to="#"  className="navbar-link-color-btn " >
                IVEY design build
              </Link>
            </div>
            <div className="nav-top-tab " onClick={() => window.open('https://iveypunch.com/', '_blank')}>
              <Link to="#" target="_blank" className="navbar-link-color-btn" >
                IVEY PuNCH
              </Link>
            </div>
            <div className="nav-top-tab"  onClick={() => window.open('https://iveyfd.org/', '_blank')}>
              <Link to="#" target="_blank" className="navbar-link-color-btn" >
                IVEY FOUNDATIOn
              </Link>
            </div>
          </div>
        </div>
      </div>


      {isPopup === true ?
        <>
          <ContactPopup setPopup={setPopup} />
        </> : <></>}
      <div className={`header-navbar  ${isMenuOpen ? 'show' : ''}`}>
        <Link to="/" className="header-logo-menu">
          <img src={blacklogo} alt="header-logo" />
          <span className="navbar-toggler-icon navbar-close-btn">
            <img src={closeIcon} alt="close-icon" style={{ color: 'black' }} />
          </span>
        </Link>

        <div className='mega-menu-botm d-flex'>
          <div className='mega-menu-tabs text-black'>
            <ul className='mega-menu-tab-title'>
              {menuItems.map((item, index) => (
                (item.mainLink !== "" && item?.subMenus.length === 0) ? (
                  <li
                    key={index}
                    className={`font-12 text-uppercase ${selectedTabIndex !== null && selectedTabIndex === index ? 'active' : ''}`}
                    onMouseLeave={() => setSelectedTabIndex(null)}
                    onMouseEnter={() => setSelectedTabIndex(index)}
                  >
                    <Link
                      to={item.mainLink}
                      onClick={() => setSelectedTabIndex(index)}
                    >
                      <span>{item.name}</span>
                    </Link>
                  </li>
                ) : (
                  <li
                    key={index}
                    className={`font-12 text-uppercase hasSubmenu ${selectedTabIndex !== null && selectedTabIndex === index ? 'active' : ''}`}
                    onMouseLeave={() => setSelectedTabIndex(null)}
                    onMouseEnter={() => setSelectedTabIndex(index)}
                  >
                    <span
                      onClick={() => setSelectedTabIndex(index)}
                    >
                      {item.name}
                    </span>

                    <ul class="sub-menu">

                      {selectedTabIndex !== null && selectedTabIndex === index && (item?.subMenus.map(item => (
                        <li><Link to={item.link} className='font-18 menu-link font-medium'>
                          {item.name}
                        </Link></li>
                      )))}

                    </ul>
                  </li>
                )

              ))}
            </ul>
          </div>
          <div className='mega-menu-tab-panel'>
            <div className='tab-panel-desc'>
              <div className='tab-panel-desc-right'>
                {/* {selectedTabIndex !== null ? tabContent[selectedTabIndex].sliderContent : tabContent[0].sliderContent} */}

                {(projects && projects.length > 0) && (
                  <div className='mega-menu-slider'>
                    <Slider {...megamenusliderSettings}>
                      {projects?.map((item, key) => (
                        <div className='home-recent-project-item' key={key}>
                          <div className='recent-featured-img'>
                            <Link to={item.slug}><img src={config.BASE_URL + item?.featuredImage} alt="featured" /></Link>
                          </div>
                          <div className='recent-project-detail d-flex'>
                            <span className='project-name font-11 font-medium text-uppercase text-black'><Link to={item.slug}>{item?.title}</Link></span>
                            <span className='project-scale font-11 text-black'>{item?.space}</span>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;